import React from 'react';
import Navigation from '@/components/Navigation';
import HeroSection from '@/components/HeroSection';
import ManifestoSection from '@/components/ManifestoSection';
import ServicesSection from '@/components/ServicesSection';
import PortfolioSection from '@/components/PortfolioSection';
import AboutSection from '@/components/AboutSection';
import ConsultationSection from '@/components/ConsultationSection';
import FooterSection from '@/components/FooterSection';

export default function HomePage() {
  return (
    <div className="grain-overlay" data-testid="home-page">
      <Navigation />
      <HeroSection />
      <ManifestoSection />
      <ServicesSection />
      <PortfolioSection />
      <AboutSection />
      <ConsultationSection />
      <FooterSection />
    </div>
  );
}
